import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  grid-column: span 12;
`;

export const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Index = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
`;

export const DropdownContainer = styled.div`
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
